var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"historical-record"},[_c('div',{ref:"scrollContainer",staticClass:"historical-record-title"},[(_vm.isLoading)?_c('van-loading'):_vm._e(),(_vm.flagType=='')?_c('span',[_vm._v(" "+_vm._s(_vm.flag ? "加载完成" : "")+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.flagType)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }